import { SIZE_TO_FIT } from "../actions/types";

export const sizeToFitRedcuer = (state = false, action) => {
  switch (action.type) {
    case SIZE_TO_FIT:
      return action.payload;
    default:
      return state;
  }
};
